export const HERO_COMPONENTS = {
    HeroBannerAlpha: 'HeroBannerAlpha',
    HeroBannerBeta: 'HeroBannerBeta',
    HeroBannerEta: 'HeroBannerEta',
};
